import React from 'react';

export default function HistoryMatch(props){
    let roster=[];
    Object.keys(props.roster).map((gamertag, index)=>{

        let total = 0;
        props.roster[gamertag].forEach(teeStrokes=>{
            total+=teeStrokes
        });

        roster.push(
            <tbody key={index}>
                <tr>
                    <th>{gamertag}</th>
                    <th>{props.roster[gamertag][0]}</th>
                    <th>{props.roster[gamertag][1]}</th>
                    <th>{props.roster[gamertag][2]}</th>
                    <th>{props.roster[gamertag][3]}</th>
                    <th>{props.roster[gamertag][4]}</th>
                    <th>{props.roster[gamertag][5]}</th>
                    <th>{props.roster[gamertag][6]}</th>
                    <th>{props.roster[gamertag][7]}</th>
                    <th>{props.roster[gamertag][8]}</th>
                    <th>{props.roster[gamertag][9]}</th>
                    <th>{props.roster[gamertag][10]}</th>
                    <th>{props.roster[gamertag][11]}</th>
                    <th>{props.roster[gamertag][12]}</th>
                    <th>{props.roster[gamertag][13]}</th>
                    <th>{props.roster[gamertag][14]}</th>
                    <th>{props.roster[gamertag][15]}</th>
                    <th>{props.roster[gamertag][16]}</th>
                    <th>{props.roster[gamertag][17]}</th>
                    <th className="th-total">Total: {total}</th>
                </tr>
            </tbody>

        );

        return false;
    });

    return(
        <details id="past-matches" className="hideOverflow">
            <summary>{props.title} at {props.location} on {props.date}.</summary>
            <table className="scrollX">
                <tbody>
                <tr>
                    <th className="th-player">Player</th>
                    <th>01 &#9900;</th>
                    <th>02 &#9900;</th>
                    <th>03 &#9900;</th>
                    <th>04 &#9900;</th>
                    <th>05 &#9900;</th>
                    <th>06 &#9900;</th>
                    <th>07 &#9900;</th>
                    <th>08 &#9900;</th>
                    <th>09 &#9900;</th>
                    <th>10 &#9900;</th>
                    <th>11 &#9900;</th>
                    <th>12 &#9900;</th>
                    <th>13 &#9900;</th>
                    <th>14 &#9900;</th>
                    <th>15 &#9900;</th>
                    <th>16 &#9900;</th>
                    <th>17 &#9900;</th>
                    <th>18</th>
                </tr>
                </tbody>
                {roster}
            </table>
        </details>
    );
}


// WEBPACK FOOTER //
// ./src/comps/historyMatch.js